module.exports = __webpack_public_path__ + "static/img/veventpromotion.a5c1551f.png";